export const CONSULT_HISTORY_RETRIEVE_REQUESTED = 'CONSULT_HISTORY_RETRIEVE_REQUESTED';
export const CONSULT_HISTORY_RETRIEVE_SUCCEED = 'CONSULT_HISTORY_RETRIEVE_SUCCEED';
export const CONSULT_HISTORY_RETRIEVE_FAILED = 'CONSULT_HISTORY_RETRIEVE_FAILED';
